import '@scss/main';
import '@fortawesome/fontawesome-free/js/all.js';
import MobileMenu from '@modules/mobile-menu';

document.addEventListener('DOMContentLoaded', () => {
  const scrolledListeners = document.querySelectorAll('.js-add-scrolled');

  document.addEventListener('scroll', e => {
    const isScrolled = window.scrollY >= 100;

    scrolledListeners.forEach(el => {
      el.classList.toggle('scrolled', isScrolled);
    });
  });

  new MobileMenu;
});
